@if (_currentData && _currentData.showForm) {
  @if (_currentData.currentFormFields && _currentData.action == 'MODIFY') {
    <dhs-form  [action]="'MODIFY'"
      (questionValueChanged)="questionChange($event)" [fieldGroup]="_currentData.currentFormFields"
      [config]="_currentData.configForm" [data]="_currentData.defaultFormData"
      (saveFinished)="onSaveFinished($event)">
    </dhs-form>
  }
}